import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { useContext } from 'react';

import { LearningOpportunityCardShort } from './learning-opportunity/LearningOpportunityCardShort';
import { ApplicationContext } from '../../../../shared/source/context/context';
import { Subtitle2 } from '../../design/components/Typography';

import type { LearningOpportunity } from '../../../../shared/source/data-contract/learning-opportunities';
import type { FunctionComponent } from 'react';

const visibleLearningRecommendations = 5;

type LearningRecommendationSectionProps = {
    readonly learningRecommendations: readonly LearningOpportunity[];
    readonly onLearningOpportunityClick?: (learningOpportunity: LearningOpportunity) => void;
    readonly onViewAllClick: () => void;
};

export const LearningRecommendationSection: FunctionComponent<LearningRecommendationSectionProps> = ({
    learningRecommendations,
    onLearningOpportunityClick,
    onViewAllClick,
}) => {
    const { translate } = useContext(ApplicationContext);

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 2,
                mb: 1,
            }}
        >
            <Subtitle2>{translate('pages.job-detail.user-matching.relevant-learning-opportunities')}</Subtitle2>
            <Box
                sx={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: 2,
                }}
            >
                {learningRecommendations.slice(0, visibleLearningRecommendations).map((learningOpportunity) => (
                    <LearningOpportunityCardShort
                        key={learningOpportunity.id}
                        id={learningOpportunity.id}
                        title={learningOpportunity.title}
                        onClick={() => {
                            onLearningOpportunityClick?.(learningOpportunity);
                        }}
                    />
                ))}
                {learningRecommendations.length > visibleLearningRecommendations && (
                    <Button
                        aria-label="View all learning opportunities"
                        color="secondary"
                        sx={{
                            alignItems: 'center',
                            backgroundColor: 'background.paper',
                            borderColor: 'cardborder.main',
                            borderRadius: '8px',
                            borderStyle: 'solid',
                            borderWidth: 1,
                            display: 'flex',
                            height: '96px',
                            justifyContent: 'center',
                            width: '354px',
                        }}
                        onClick={onViewAllClick}
                    >
                        {translate('pages.job-detail.user-matching.view-all')}
                    </Button>
                )}
            </Box>
        </Box>
    );
};
